const osTitles = [{
            cName: "APPLICATION FOR FLORIDA TITLE with OUT-OF-STATE TITLE",
            oSubMenu: [{
                    cName: "VEHICLE, Private Use, OUT-OF-STATE application for Florida title",
                    cReturn: "VEHICLE, Private Use, OUT-OF-STATE application for Florida title|85.25|1"
                },
                {
                    cName: "VEHICLE, Lease or For Hire, Auto (not Pickup or Truck), OUT-OF-STATE APPLICATION FOR FLORIDA TITLE",
                    cReturn: "VEHICLE, OUT-OF-STATE application for Florida title, Lease or For Hire, Auto|64.25|6"
                },
                {
                    cName: "VEHICLE, Lease or For Hire, Not Auto, (includes Pickup, Truck, Motorcycles, etc), OUT-OF-STATE APPLICATION FOR FLORIDA TITLE",
                    cReturn: "VEHICLE, OUT-OF-STATE application for Florida title, Lease or For Hire, Not Auto, (includes Pickup, Truck, Motorcycles, etc)|85.25|1"
                },
                {
                    cName: "MOBILE HOME, Private or Lease, OUT-OF-STATE APPLICATION FOR FLORIDA TITLE,",
                    cReturn: "MOBILE HOME, OUT-OF-STATE application for Florida title|85.25|4"
                },
                {
                    cName: "VESSEL, OUT-OF-STATE APPLICATION FOR FLORIDA TITLE,",
                    cReturn: "VESSEL, OUT-OF-STATE application for Florida title|9.25|5"
                },
                {
                    cName: "OFF-HIGHWAY VEHICLE, OUT-OF-STATE APPLICATION FOR FLORIDA TITLE, with title decal",
                    cReturn: "OFF-HIGHWAY VEHICLE, OUT-OF-STATE application for Florida title, with title decal|42.50|7"
                },
                {
                    cName: "TRAILER < 1999 lbs - No Title required",
                    bEnabled: false,
                    cReturn: "Trailer < 1999 lbs - No Title required|0.00|2"
                },
                {
                    cName: "Moped - No Title required",
                    bEnabled: false,
                    cReturn: "Moped - No Title required| 0.00|2"
                },
                {
                    cName: "Motorcycle < 2 BHP and 50 CC - No Title required",
                    bEnabled: false,
                    cReturn: "Motorcycle < 2 BHP and 50 CC - No Title required|0.00|2"
                },
                {
                    cName: "Motorized Bicycle - No Title required",
                    bEnabled: false,
                    cReturn: "Motorized Bicycle - No Title required|0.00|2"
                }
            ]
        }, //Repossession
        {
            cName: "REPOSSESSION BY LIENHOLDER, OUT-OF-STATE TITLE",
            oSubMenu: [{
                    cName: "REPOSSESSION BY LIENHOLDER (TITLE)",
                    cReturn: "Repossession, (Title), OUT-OF-STATE TITLE|85.25|8"
                },
                {
                    cName: "REPOSSESSION BY LIENHOLDER (CERTIFICATE OF REPOSSESSION)",
                    cReturn: "Repossession, (Certificate of Repossession), OUT-OF-STATE TITLE|85.25|8|0|2"
                },
                {
                    cName: "REPOSSESSION BY LIENHOLDER, FOR HIRE, (TITLE)",
                    cReturn: "Repossession, FOR HIRE, (Title), OUT-OF-STATE TITLE|64.25|8"
                },
                {
                    cName: "REPOSSESSION BY LIENHOLDER, FOR HIRE, (CERTIFICATE OF REPOSSESSION)",
                    cReturn: "Repossession, FOR HIRE, (Certificate of Repossession), OUT-OF-STATE TITLE|64.25|8|0|2"
                },
                {
                    cName: "VESSEL REPOSSESSION BY LIENHOLDER (TITLE)",
                    cReturn: "Vessel repossession (Title), OUT-OF-STATE TITLE|9.25|5"
                },
                {
                    cName: "VESSEL REPOSSESSION BY LIENHOLDER (CERTIFICATE OF REPOSSESSION)",
                    cReturn: "Vessel repossession (Certificate of Repossession), OUT-OF-STATE TITLE|9.25|5|0|2"
                },
                {
                    cName: "REASSIGNMENT PLUS REPOSSESSION BY LIENHOLDER",
                    cReturn: "Reassignment plus repossession by lienholder, OUT-OF-STATE TITLE|88.25|8"
                }
            ] //TITLE FEE AND ADD3.00.
        }, //Salvage
        {
            cName: "SALVAGE APPLICATION, OUT-OF-STATE TITLE",
            oSubMenu: [{
                cName: "SALVAGE TITLE APPLICATION",
                cReturn: "SALVAGE title application, OUT-OF-STATE TITLE|17.25|8"
            }]
        }, {
            cName: "REBUILT APPLICATION, OUT-OF-STATE TITLE",
            oSubMenu: [{
                    cName: "REBUILT VEHICLE, Private Use",
                    cReturn: "REBUILT VEHICLE, Private Use, OUT-OF-STATE TITLE (includes $40 inspection fee)|125.25|1"
                },
                {
                    cName: "REBUILT VEHICLE, FOR HIRE",
                    cReturn: "REBUILT VEHICLE, FOR HIRE, OUT-OF-STATE TITLE (includes $40 inspection fee)|104.25|2"
                }
            ]
        }, {
            cName: "CERTIFICATE OF DESTRUCTION, OUT-OF-STATE",
            oSubMenu: [{
                cName: "CERTIFICATE OF DESTRUCTION",
                cReturn: "CERTIFICATE OF DESTRUCTION, OUT-OF-STATE|17.25|8|0|2"
            }]
        }];

module.exports = osTitles;



// WEBPACK FOOTER //
// ./src/modules/data/os-titles.js